import { create } from 'zustand';
import type { User } from './types';

interface AuthState {
  token: string | null;
  user: User | null;
  expiresAt: number;
  ready: boolean;
  setSession(token: string, user: User, expiresIn: number): void;
  setUser(user: User): void;
  clear(): void;
  setReady(): void;
}

/** Access token lives in memory only; the refresh token is an httpOnly cookie (§13). */
export const useAuth = create<AuthState>((set) => ({
  token: null,
  user: null,
  expiresAt: 0,
  ready: false,
  setSession: (token, user, expiresIn) => set({ token, user, expiresAt: Date.now() + expiresIn * 1000, ready: true }),
  setUser: (user) => set({ user }),
  clear: () => set({ token: null, user: null, expiresAt: 0, ready: true }),
  setReady: () => set({ ready: true }),
}));
